import { Button, Tooltip, UnlockIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

type EnableProReportingButtonProps = {
  text: string;
};

export const EnableProReportingButton: React.FC<
  EnableProReportingButtonProps
> = ({ text }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <Tooltip title={t("reporting.proreporting.tooltip")}>
        <Button
          type="primary"
          icon={<UnlockIcon />}
          data-cy-id="enable-pro-reporting-button"
          onClick={() => {
            navigate("/reporting/machine/status");
          }}
        >
          {text}
        </Button>
      </Tooltip>
    </>
  );
};
